import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { AlertDialog, Button } from '@homeexchange/design';
import i18n from '../../i18n';
import Conversation from '../../models/Conversation';
import User from '../../models/User';
import Analytics from '../../utils/analytics';
import { bindActionCreators } from 'redux';
import { cancelStayRequest, fetchStayRequestForConversation } from '../../actions/stayRequest';

class ButtonCancel extends React.Component {
    static propTypes = {
        conversation: PropTypes.instanceOf(Conversation).isRequired,
        user: PropTypes.instanceOf(User).isRequired,
        accessToken: PropTypes.string.isRequired,
        actions: PropTypes.shape({
            fetchStayRequestForConversation: PropTypes.func.isRequired,
            cancelStayRequest: PropTypes.func.isRequired
        })
    };

    constructor(props) {
        super(props);

        this.onClickCancelButton = this.onClickCancelButton.bind(this);
        this.cancel = this.cancel.bind(this);

        this.state = {
            showCancelPreapprobationModal: false,
            showPreapprobationModalError: false,
            isDisabled: false
        };
    }

    render() {
        return (
            <>
                <Button
                    size="medium"
                    hierarchy="secondary"
                    isDisabled={this.state.isDisabled}
                    onClick={this.onClickCancelButton}
                    isFullWidth
                >
                    {i18n.t('exchange:cancel_pre_approval')}
                </Button>
                <AlertDialog
                    isOpen={this.state.showCancelPreapprobationModal}
                    title={i18n.t('exchange:confirm_cancel_preapprove_title')}
                    confirmActionText={i18n.t('common:continue')}
                    onConfirmAction={() => {
                        this.setState({ showCancelPreapprobationModal: false });
                        this.cancel();
                    }}
                    dismissActionText={i18n.t('common:cancel')}
                    onDismissAction={() => {
                        this.setState({ showCancelPreapprobationModal: false });
                    }}
                >
                    {i18n.t('exchange:confirm_cancel_preapprove_text')}
                </AlertDialog>
                {this.state.showPreapprobationModalError && (
                    <AlertDialog
                        isOpen={this.state.showPreapprobationModalError}
                        iconStatus="error"
                        confirmActionText={i18n.t('common:modal.error-occured.cta')}
                        title={i18n.t('common:modal.error-occured.title')}
                        onConfirmAction={() => {
                            this.setState({ showPreapprobationModalError: false });
                        }}
                    >
                        {i18n.t('common:modal.error-occured.content')}
                    </AlertDialog>
                )}
            </>
        );
    }

    onClickCancelButton(event) {
        event.preventDefault();
        this.setState({ showCancelPreapprobationModal: true });
    }

    cancel() {
        const { user } = this.props;

        // disable button
        this.setState({
            isDisabled: true
        });

        // send request
        return this.props.actions
            .cancelStayRequest(this.props.conversation.id)
            .then(() => {
                this.props.actions.fetchStayRequestForConversation(this.props.conversation);
                Analytics.trackGTM('exchange_status', {
                    event_data: {
                        exchange_status: 'preapprobation_cancelled',
                        collection: user.isCollection()
                    }
                });
            })
            .catch(() => {
                this.setState({
                    showPreapprobationModalError: true
                });
            })
            .finally(() => {
                this.setState({
                    isDisabled: false
                });
            });
    }
}

const mapStateToProps = (state) => ({
    accessToken: state.auth.accessToken
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                fetchStayRequestForConversation,
                cancelStayRequest
            },
            dispatch
        )
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ButtonCancel);
